<template>
    <div class="container">
        <brand-logo large></brand-logo>
        <summoner-search center large></summoner-search>
        <p class="brand-lead">
            League of Legends League Points Tracker
        </p>
    </div>
</template>

<script>
import BrandLogo from '@/components/BrandLogo'
import SummonerSearch from '@/components/SummonerSearch'

export default {
  components: {
    BrandLogo,
    SummonerSearch,
  },
}
</script>

<style lang="sass" scoped>
.container
    text-align: center

.brand-logo
    margin-bottom: 0
    line-height: 1

.summoner-search
    margin-top: 4rem
    margin-bottom: 4rem

.brand-lead
    margin-top: 4rem
    text-transform: uppercase
    font-weight: 500
</style>



// WEBPACK FOOTER //
// LandingPage.vue?72a2e08e